export function GetMockApplicantRead() {
  return {
    id: 1,
    jmCaseId: 1,
    applicantName: "Lindsay Davey",
    applicantEmail: "lindsaycrampton@yahoo.co.uk",
    applicantPhone1: "07769661865",
    applicantPhone2: null,
    applicantAddress: "Colwyn House",
    applicantTown: "Colchester",
    applicantCounty: "Essex",
    applicantPostcode: "CO3 3LD",
    employmentStatusId: 36,
    otherPropertyOwned: 0,
    willPropBeSold: 0,
  };
}
